import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';

export interface RegisterMemberPaymentReportParams {
  siteId: number;
  subscriptionId?: number | null;
  vehicleTypeId?: number | null;
  startDate: string;
  endDate: string;
}

@Injectable({ providedIn: 'root' })
export class ApiRegisterMemberPaymentReportService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);
  private readonly http = inject(HttpClient);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getRegisterMemberPaymentForTable(params: RegisterMemberPaymentReportParams): Observable<unknown> {
    const query: Record<string, string | number> = {
      siteId: params.siteId,
      startDate: params.startDate,
      endDate: params.endDate,
    };
    if (params.subscriptionId != null && params.subscriptionId > 0) {
      query['subscriptionId'] = params.subscriptionId;
    }
    if (params.vehicleTypeId != null && params.vehicleTypeId > 0) {
      query['vehicleTypeId'] = params.vehicleTypeId;
    }

    return this.apiMethodService.request(
      '/FinanceReports/getRegisterMemberPaymentForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getRegisterMemberPaymentForTable',
        token: this.token,
        headerOnly: false,
        params: query,
      },
    );
  }

  getRegisterMemberPaymentPdf(params: RegisterMemberPaymentReportParams): Observable<Uint8Array> {
    let httpParams = new HttpParams()
      .set('siteId', params.siteId)
      .set('startDate', params.startDate)
      .set('endDate', params.endDate);
    if (params.subscriptionId != null && params.subscriptionId > 0) {
      httpParams = httpParams.set('subscriptionId', params.subscriptionId);
    }
    if (params.vehicleTypeId != null && params.vehicleTypeId > 0) {
      httpParams = httpParams.set('vehicleTypeId', params.vehicleTypeId);
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.token}`,
      Accept: 'application/octet-stream, application/pdf, */*',
    });

    return this.http
      .get(`${this.baseUrl}/Reports/register-member-payment/pdf`, {
        headers,
        params: httpParams,
        responseType: 'arraybuffer',
      })
      .pipe(map((buffer) => new Uint8Array(buffer)));
  }
}
